module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_4.3ff340e8.png";